import PetOwnerView from './PetFriendResolver';
import abi from './abi';
import extraDataComponent from './ExtraData';

const requiredAllowance = '1';

export {
  PetOwnerView,
  abi,
  extraDataComponent,
  requiredAllowance,
};
